// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import { lazy } from 'react-loosely-lazy';
import type StartSprintModalType from '@atlassian/jira-software-start-sprint-modal-relay';
import { StartSprintModalBoundary } from '@atlassian/jira-software-start-sprint-modal-relay/async';
import { BACKLOG_PACKAGE_NAME } from '../../../../common/constants/analytics';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const StartSprintModal = lazy<typeof StartSprintModalType>(
	() =>
		import(
			/* webpackChunkName: "async-start-sprint-modal-relay" */ '@atlassian/jira-software-start-sprint-modal-relay'
		),
);

type Props = JSX.LibraryManagedAttributes<
	typeof StartSprintModalType,
	ComponentProps<typeof StartSprintModalType>
>;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ ...props }: Props) => (
	<StartSprintModalBoundary packageName={BACKLOG_PACKAGE_NAME}>
		<StartSprintModal {...props} />
	</StartSprintModalBoundary>
);
